// extracted by mini-css-extract-plugin
export default {"button":"RemoveCandidatesButton_button__SnOZe","body":"RemoveCandidatesButton_body__Mats0"};